import React from 'react';
import moment from 'moment';
import { decodeText } from '../libs/utils/Const';

const renderTableBody = (headers, data, checkbox, openDetails) => {
    const body = data.map((wareHouse, index) => {
        return (
            <tr key={index}>
                {headers[0].value && <td>{wareHouse?.ROW ?? ''}</td>}
                {headers[1].value && <td>{wareHouse?.WhsCode ?? ''}</td>}
                {headers[2].value && <td>{decodeText(wareHouse?.WhsName) ?? ''}</td>}


                <td class="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                        onClick={() => openDetails(wareHouse)}
                        style={{ fontWeight: '500' }}>
                        <i class="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>
        )

    })
    return body;
};

const renderTable = (headers, data, checkbox, openDetails) => {

    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            {headers[0].value && <td style={{ width: '10%' }}>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            <td class="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderWareHouseAdminList = (headers, data, checkbox, openDetails) => {

    return renderTable(headers, data, checkbox, openDetails);

}